<template>
  <div style="min-height: 150px">
    <div style="padding: 15px 10px;">
      <div style="margin: 0 0 20px">
        <el-button type="primary" :loading="exportLoading" @click="exportData">
          导出
        </el-button><span style="margin-left: 25px;color: red">
          如果实际结算金额为零时，请代理商先发布完合同信息后，再关注，谢谢！{{ this.specialCloudDesc }}
          若代理商发布合同时间和订单员发布合同时间间隔大于2天,则期望发货日期会在选择的日期上顺延相应间隔天数
        </span>
      </div>
      <div class="row-tip">
        <!-- <span v-if="address" style="display:inline-block;margin:0 0 20px 0">
          配送至：{{ address.province }}{{ address.city }}{{ address.county }}{{ address.receiptAddress }}
          <span class="ml-10">{{ address.receiverName }}：</span>
          <span>{{ address.receiverPhone }}</span>
        </span> -->

        <template v-if="String($route.query.isSon) !== 'true' ">
          <el-form ref="baseForm" :model="formData" :inline="true" class="form-wrap">
            <el-form-item label="特殊发货需求" required>
              <el-select v-model="formData.multiaddress" placeholder="请选择">
                <el-option v-for="item in warehouseList" :key="item.dictLabel" :label="item.dictValue" :value="item.dictLabel" />
              </el-select>
              <el-input v-if="formData.multiaddress ==='其他'" v-model="multiaddressValue" maxlength="50" @click.native.stop="stopProp" />
            </el-form-item>
            <el-form-item label="特殊开票需求" required>
              <el-select
                v-model="formData.specialTicketRequirements"
                placeholder="请选择"
                style="width: 150px;"
                @change="formData.otherTxet = ''"
              >
                <el-option
                  v-for="(item, index) in specialInvoicingList"
                  :key="index"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
              <!-- 选择[其他特殊需求]，填写内容 -->
              <el-input
                v-if="formData.specialTicketRequirements === '其他特殊需求'"
                v-model="formData.otherTxet"
                :maxlength="100"
                style="width: 200px;"
              />
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="submitMultiaddress">
            保存
          </el-button>
        </template>
      </div>

      <div v-if="customizationList.length" class="custom-pro-wrap">
        此单涉及定制化产品，具体型号为：
        <el-tag
          v-for="(item, index) in customizationList"
          :key="index"
          class="tag-cell"
        >
          {{ item.productName }}
        </el-tag>
        下单时请代理商支付此合同全部货款的30%进行下单，有疑问，请联系对应销售。
      </div>
      <div v-if="contractType === '国际业务下单' || contractType === '国际分销下单'">
        <el-table :data="tableData" border style="width: 100%" :summary-method="getSummaries" show-summary>
          <el-table-column type="index" width="50" label="序号" align="left" fixed="left" />
          <el-table-column prop="productCode" label="销售产品代码" align="left" min-width="120" fixed="left" />
          <el-table-column prop="productInvoiceName" label="商品名称" align="left" min-width="150" />
          <el-table-column prop="productName" label="规格型号" align="left" min-width="150" />
          <el-table-column prop="counct" label="数量" align="left" width="60">
            <template v-slot="{row}">
              <span v-if="contractType !=='服务订单'">{{ Number(row.counct).toFixed(0) }}</span>
              <span v-else>{{ Number(row.serviceLife) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productUnit" label="单位" align="left" width="100" />
          <el-table-column prop="productPriceSigle" label="单价" align="right" width="100" header-align="left" />
          <el-table-column prop="orderAmount" label="订单金额" align="right" width="120" header-align="left" />
          <el-table-column prop="beforeSplitProductPriceSigle" label="拆分前单价" align="right" width="100" header-align="left" />
          <el-table-column prop="settlementAmount" label="实际结算金额" align="right" width="100" header-align="left" />
          <el-table-column prop="pname" label="是否购买PSC" align="left">
            <template v-slot="{row}">
              {{ row.buyPsc=='Y'?'是':row.buyPsc=='N'?'否':'' }}
            </template>
          </el-table-column>
          <el-table-column prop="expectedDeliveryDate" label="期望发货日期" align="left" width="100">
            <template v-slot="{row}">
              {{ row.expectedDeliveryDate && row.expectedDeliveryDate.substr(0,11) }}
            </template>
          </el-table-column>
          <el-table-column prop="taxName" label="税收分类名称" align="left" width="100" />
          <el-table-column prop="taxRate" label="税率" align="right" width="50" header-align="left">
            <template v-slot="{row}">
              {{ row.taxRate }}<span v-show="row.taxRate">%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="productConfigInfo"
            label="产品配置描述"
            align="left"
            min-width="100"
          />
          <el-table-column prop="serviceDesc" label="服务备注" align="left" width="100" />
        </el-table>
      </div>
      <div v-if="contractType !== '国际业务下单' && contractType !== '国际分销下单'">
        <div v-for="(item, key) in showData" :key="key">
          <div class="marginBottom">收货地址：{{ key }}</div>
          <el-table :data="item" border style="width: 100%" :summary-method="getSummariesSmall" show-summary sum-text="小计">
            <el-table-column type="index" width="50" label="序号" align="left" fixed="left" />
            <el-table-column prop="productCode" label="销售产品代码" align="left" min-width="120" fixed="left" />
            <el-table-column prop="productInvoiceName" label="商品名称" align="left" min-width="150" />
            <el-table-column prop="productName" label="规格型号" align="left" min-width="150" />
            <el-table-column prop="counct" label="数量" align="left" width="60">
              <template v-slot="{row}">
                <span v-if="contractType !=='服务订单'">{{ Number(row.counct).toFixed(0) }}</span>
                <span v-else>{{ Number(row.serviceLife) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="productUnit" label="单位" align="left" width="100" />
            <el-table-column prop="productPriceSigle" label="单价" align="right" width="100" header-align="left" />
            <el-table-column prop="orderAmount" label="订单金额" align="right" width="120" header-align="left" />
            <el-table-column prop="beforeSplitProductPriceSigle" label="拆分前单价" align="right" width="100" header-align="left" />
            <el-table-column prop="settlementAmount" label="实际结算金额" align="right" width="100" header-align="left" />
            <el-table-column prop="pname" label="是否购买PSC" align="left">
              <template v-slot="{row}">
                {{ row.buyPsc=='Y'?'是':row.buyPsc=='N'?'否':'' }}
              </template>
            </el-table-column>
            <el-table-column prop="isBorrow" label="是否冲销" align="left">
              <template v-slot="{row}">
                {{ row.isBorrow ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column prop="expectedDeliveryDate" label="期望发货日期" align="left" width="100">
              <template v-slot="{row}">
                {{ row.expectedDeliveryDate && row.expectedDeliveryDate.substr(0,11) }}
              </template>
            </el-table-column>
            <el-table-column prop="taxName" label="税收分类名称" align="left" width="100" />
            <el-table-column prop="taxRate" label="税率" align="right" width="50" header-align="left">
              <template v-slot="{row}">
                {{ row.taxRate }}<span v-show="row.taxRate">%</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="productConfigInfo"
              label="产品配置描述"
              align="left"
              min-width="100"
            />
            <el-table-column prop="serviceDesc" label="服务备注" align="left" width="100" />
          </el-table>
        </div>
        <!-- 总合计区域 -->
        <el-table id="totalTable" :data="tableData" border style="width: 100%" :summary-method="getSummaries" show-summary>
          <el-table-column type="index" width="50" label="序号" align="left" fixed="left" />
          <el-table-column prop="productCode" label="销售产品代码" align="left" min-width="120" fixed="left" />
          <el-table-column prop="productInvoiceName" label="商品名称" align="left" min-width="150" />
          <el-table-column prop="productName" label="规格型号" align="left" min-width="150" />
          <el-table-column prop="counct" label="数量" align="left" width="60">
            <template v-slot="{row}">
              <span v-if="contractType !=='服务订单'">{{ Number(row.counct).toFixed(0) }}</span>
              <span v-else>{{ Number(row.serviceLife) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productUnit" label="单位" align="left" width="100" />
          <el-table-column prop="productPriceSigle" label="单价" align="right" width="100" header-align="left" />
          <el-table-column prop="orderAmount" label="订单金额" align="right" width="120" header-align="left" />
          <el-table-column prop="beforeSplitProductPriceSigle" label="拆分前单价" align="right" width="100" header-align="left" />
          <el-table-column prop="settlementAmount" label="实际结算金额" align="right" width="100" header-align="left" />
          <el-table-column prop="pname" label="是否购买PSC" align="left">
            <template v-slot="{row}">
              {{ row.buyPsc=='Y'?'是':row.buyPsc=='N'?'否':'' }}
            </template>
          </el-table-column>
          <el-table-column prop="isBorrow" label="是否冲销" align="left">
            <template v-slot="{row}">
              {{ row.isBorrow ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="expectedDeliveryDate" label="期望发货日期" align="left" width="100">
            <template v-slot="{row}">
              {{ row.expectedDeliveryDate && row.expectedDeliveryDate.substr(0,11) }}
            </template>
          </el-table-column>
          <el-table-column prop="taxName" label="税收分类名称" align="left" width="100" />
          <el-table-column prop="taxRate" label="税率" align="right" width="50" header-align="left">
            <template v-slot="{row}">
              {{ row.taxRate }}<span v-show="row.taxRate">%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="productConfigInfo"
            label="产品配置描述"
            align="left"
            min-width="100"
          />
          <el-table-column prop="serviceDesc" label="服务备注" align="left" width="100" />
        </el-table>
        <!-- <div class="total-summary">
          <el-alert title="总合计" type="info" :closable="false">
            <div class="summary-content">
              <span>总数量：{{ tableData.length }}</span>
              <span>总金额：{{ tableData.length }}</span>
            </div>
          </el-alert>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script type="es6">
// import lookserialNumber from './lookserialNumber';
import { getDictData } from '@/API/international';
import axios, { getReceiptAddressByContractId, getContractProsAndSpecialPros, getContractProsAndSpecialProsByAddress, updateMultiaddress, listSpecialTicketsRequirements, saveSpecialTicketRequirements } from '@/API';
import { MathAdd } from '@/libs/util';
import { Notification } from 'element-ui';
export default {
  props: {
    strContractCode: {
      type: String,
      required: true
    },
    specialProduct: {
      type: Number,
      default: () => { return 0; }
    },
    specialCloudDesc: {
      type: String,
      default: () => { return ''; }
    },
    contractType: {
      type: String,
      default: () => { return ''; }
    },
    multiaddress: {
      type: String,
      default: ''
    },
    multiaddressValue: {
      type: String,
      default: ''
    },
    contractId: {
      type: Number,
      default: 0
    },
    // 特殊开票需求默认值
    specialTicketRequirements: {
      type: [Object, String],
      default: null
    }
  },

  data () {
    return {
      tableData: [],
      showData: [],
      isNoData: false,
      loading: false,
      address: {},
      exportLoading: false,
      // 是否多地址发货
      formData: { multiaddress: '', specialTicketRequirements: null, otherTxet: '' },
      warehouseList: [],
      // 特殊开票需求
      specialInvoicingList: []
    };
  },

  computed: {
    // 定制化产品
    customizationList () {
      return this.tableData.filter((row) => row.customizationOrNot);
    }
  },

  watch: {
    multiaddress: {
      immediate: true,
      handler (newVal) {
        this.formData.multiaddress = newVal;
      }
    },

    specialTicketRequirements: {
      immediate: true,
      handler (newVal) {
        this.setDefaultData(this.specialInvoicingList, newVal);
      }
    }
  },

  created () {
    this.queryWarehouse();
  },

  methods: {
    // 提交多地址
    submitMultiaddress () {
      let newFormat = { multiaddress: '' };
      if (this.formData.multiaddress === '其他') {
        if (!this.multiaddressValue) {
          this.$message.error('请输入特殊发货需求');
          return;
        }
        newFormat.multiaddress = '特殊发货需求--' + this.multiaddressValue;
      } else {
        newFormat.multiaddress = this.formData.multiaddress;
      }
      let params = { ...newFormat, contractId: this.contractId };

      // 特殊开票参数
      let saveParams = {
        contractId: this.contractId,
        specialTicketRequirements: this.formData.specialTicketRequirements === '其他特殊需求' ? this.formData.otherTxet : this.formData.specialTicketRequirements
      };

      Promise.all([updateMultiaddress(params), saveSpecialTicketRequirements(saveParams)]).then(res => {
        let [data1, data2] = res;
        if (data1.data.status === '200') {
          Notification.success('特殊发货需求保存成功');
        }
        if (data2.data.status === '200') {
          Notification.success('特殊开票需求保存成功');
        }
      });
    },
    queryWarehouse () {
      let params = { dictType: 'desc_of_special_requirements' };
      getDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.warehouseList = data;
        }
      });
    },
    initData () {
      getReceiptAddressByContractId(this.$route.query.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.address = json.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    searchDetail () {
      if (this.contractType !== '国际业务下单' && this.contractType !== '国际分销下单') {
        getContractProsAndSpecialProsByAddress(this.$route.query.id, this.$route.query.isSon).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.showData = json.data;
            Object.keys(this.showData).forEach(key => {
              this.tableData = [...this.tableData, ...this.showData[key]];
            });
            this.tableData.forEach(item => {
              item.counct = item.counct ? item.counct : 0;
            });
          }
        }).catch((err) => {
          console.log(err);
        });
      } else {
        getContractProsAndSpecialPros(this.$route.query.id, this.$route.query.isSon).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.tableData = json.data;
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    },
    exportData () {
      this.exportLoading = true;
      let query = this.$route.query.isSon === true;
      axios.get(('/export/getExportContractDetailInfo?contractNum=' + this.strContractCode + '&isSon=' + query), {
        responseType: 'blob'// 服务器返回的数据类型
      }).then((res) => {
        this.exportLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '订单明细列表.xls';

        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.exportLoading = false;
      });
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.allNum();
        }
        if (column.label === '订单金额') {
          sums[index] = this.allOrderAmount();
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.allSettlementAmount();
        }
      });
      return sums;
    },
    allNum () {
      let cont = 0;
      if (this.contractType !== '服务订单') {
        this.tableData.forEach((item) => {
          cont = MathAdd(cont, item.counct || 0);
        });
      } else {
        this.tableData.forEach((item) => {
          cont = MathAdd(cont, item.serviceLife || 0);
        });
      }

      // cont = Number(cont).toFixed(2);
      return cont;
    },
    allOrderAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont = MathAdd(cont, item.orderAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    allSettlementAmount () {
      let cont = 0;
      if (this.contractType !== '国际业务下单' && this.contractType !== '国际分销下单') {
        this.tableData.forEach((item) => {
          cont = MathAdd(cont, item.settlementAmount);
        });
      } else {
        this.tableData.forEach((item) => {
          cont = MathAdd(cont, item.settlementAmountNum);
        });
      }
      cont = Number(cont).toFixed(2);
      return cont;
    },
    getSummariesSmall (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.allNumSmall(data);
        }
        if (column.label === '订单金额') {
          sums[index] = this.allOrderAmountSmall(data);
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.allSettlementAmountSmall(data);
        }
      });
      return sums;
    },
    allNumSmall (data) {
      let cont = 0;
      if (this.contractType !== '服务订单') {
        data.forEach((item) => {
          cont = MathAdd(cont, item.counct || 0);
        });
      } else {
        data.forEach((item) => {
          cont = MathAdd(cont, item.serviceLife || 0);
        });
      }

      // cont = Number(cont).toFixed(2);
      return cont;
    },
    allOrderAmountSmall (data) {
      let cont = 0;
      data.forEach((item) => {
        cont = MathAdd(cont, item.orderAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    allSettlementAmountSmall (data) {
      let cont = 0;
      data.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    stopProp (e) {
      e.stopPropagation();
    },
    // 获取 特殊开票需求
    querySpecialTicketRequirements () {
      listSpecialTicketsRequirements().then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.specialInvoicingList = data;
          // 判断返回的下拉数据类型
          this.setDefaultData(data, this.formData.specialTicketRequirements);
        }
      });
    },

    // 判断返回的下拉数据类型
    setDefaultData (list, val) {
      if (list.some(row => row.dictValue === val)) {
        this.formData.specialTicketRequirements = val;
      } else {
        if (list.length) {
          this.formData.otherTxet = val;
          this.formData.specialTicketRequirements = '其他特殊需求';
        } else {
          this.formData.specialTicketRequirements = val;
        }
      }
    }
  },
  mounted () {
    this.initData();
    this.searchDetail();
    this.querySpecialTicketRequirements();
  }
};
</script>

<style lang="scss" scoped>
.row-tip{
  display: flex;
  align-items: center;

  .form-wrap{
    margin-left: 30px;
    .el-input--mini{
          width: 100px;
          margin-left:10px
    }
  }

  button{
    position: relative;
    top: -10px;
  }
}

.custom-pro-wrap {
  padding: 10px 0;
  color: red;

  .tag-cell {
    margin-right:8px;
  }
}

.ml-10{
  margin-left: 10px;
}

.marginBottom{
  padding: 15px 10px;
  border: 1px solid #ebeef5;
}

:deep(#totalTable){
  margin-top: 20px;
}

:deep(#totalTable > div){
  display: none !important;
}

:deep(#totalTable .el-table__footer-wrapper){
  display: block!important;
}

:deep(#totalTable .el-table__cell:first-child .cell){
  visibility: visible!important;
}
</style>
